import api from '../../utils/apiUtils';

export const ADD_QUESTIONNAIRE = 'ADD_QUESTIONNAIRE';
export const ADD_SECTIONS = 'ADD_SECTIONS';
export const RESET = 'RESET';
export const SET_CURRENT_POSITION = 'SET_CURRENT_POSITION';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SUBMIT_QUESTIONNAIRE_SUCCESS = 'SUBMIT_QUESTIONNAIRE_SUCCESS';
export const SUBMIT_QUESTIONNAIRE_ERROR = 'SUBMIT_QUESTIONNAIRE_ERROR';

export const setMessage = (message: string) => ({
    type: SET_MESSAGE,
    payload: message
});

export const submitFilledQuestionnaire = () => {
    return async (dispatch: any, getState: any) => {
        const state = getState();
        const filledQuestionnaireState = state.filledQuestionnaire;

        // Build the questionnaire object for submission
        const questionnaireData = {
            questionnairesId: filledQuestionnaireState.questionnairesId,
            fullName: filledQuestionnaireState.fullName,
            companyName: filledQuestionnaireState.companyName,
            email: filledQuestionnaireState.email,
            role: filledQuestionnaireState.role,
            industry: filledQuestionnaireState.industry,
            country: filledQuestionnaireState.country,
            companySize: filledQuestionnaireState.companySize,
            filledSections: filledQuestionnaireState.filledSections,
            lastCompletedPhasesIds: filledQuestionnaireState.lastCompletedPhasesIds,
            message: filledQuestionnaireState.message
        };

        try {
            const response = await api.post('/filled-questionnaires', questionnaireData);
            dispatch({
                type: SUBMIT_QUESTIONNAIRE_SUCCESS,
                payload: response.data
            });
            // Don't reset here - let the thank-you page handle the reset
            // This prevents the LeaveNote useEffect from redirecting before navigation completes
            return response.data;
        } catch (error) {
            dispatch({
                type: SUBMIT_QUESTIONNAIRE_ERROR,
                payload: error
            });
            throw error;
        }
    };
};